import React from 'react';

/**
 * Circular progress indicator for the setup launcher and panel header.
 *
 * The dash geometry is computed from the radius rather than hardcoded, so the
 * ring stays correct at any size. `strokeDasharray` / `strokeDashoffset` are SVG
 * geometry attributes, not styling — colour, width and size all come from
 * tokens in onboarding-widget.scss.
 */
export function ProgressRing({ value = 0, total = 0, size = 26, children }) {
  const pct = total > 0 ? Math.min(1, Math.max(0, value / total)) : 0;
  const strokeWidth = size <= 30 ? 3 : 4;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  return (
    <span className="rc-ob-ring" data-complete={pct === 1 ? 'true' : 'false'}>
      <svg
        className="rc-ob-ring__svg"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        aria-hidden="true"
        focusable="false"
      >
        <circle
          className="rc-ob-ring__track"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={strokeWidth}
        />
        <circle
          className="rc-ob-ring__fill"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - pct)}
        />
      </svg>
      {children ? <span className="rc-ob-ring__label">{children}</span> : null}
    </span>
  );
}

export default ProgressRing;
